import * as Preferences from "~/Preferences";
import { Table as GenericTable } from "~/TableV2";
import { Empty } from "antd";
import React from "react";
import { ColumnGroupType, ColumnType } from "antd/lib/table";

export function DisabledTable(
    {
      columns,
      isLoading,
      disabledText = "Please select filters to view table",
    }: {
      readonly columns: readonly unknown[];
      readonly isLoading: boolean;
      readonly disabledText: string;
    }) {

    return(
        <GenericTable
            loading={isLoading}
            locale={
            {emptyText: <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={isLoading ? "No Data" : disabledText}
            />}
            }
            // eslint-disable-next-line functional/prefer-readonly-type
            columns={columns as (ColumnGroupType<Record<string, unknown>> | ColumnType<Record<string, unknown>>)[]}
        />
    )

}

export function shouldShowSelectAFilterPrompt(parameters: {
  readonly companyId: string,
  readonly userPreferences: Preferences.UserPreferences<unknown>,
  readonly isPageUnassignedLogs?: boolean,
}){
    const isCompany1854 = parameters.companyId == '1854';
    const branchIds = parameters.userPreferences[Preferences.preferenceKey("branchFilter")]
    const locationIds = parameters.userPreferences[Preferences.preferenceKey("locationFilter")]
    const assetIds = parameters.userPreferences[Preferences.preferenceKey("assetFilter")]

    if(parameters.isPageUnassignedLogs ?? false){
      return isCompany1854 && checkIfEmptyList(branchIds) && checkIfEmptyList(assetIds)
    }
    return isCompany1854 && checkIfEmptyList(branchIds) && checkIfEmptyList(locationIds)
}

export function checkIfEmptyList(list: unknown) {
    if(Array.isArray(list)){
      return (list as readonly number[]).length == 0
    }
    return true
  }